import React from 'react';
import { FormattedMessage } from 'react-intl';

export function RichMessage (props) {
  const { values, ...rest } = props;

  return (
    <FormattedMessage
      {...rest}
      values={{
        // preserve caller values
        ...values,
        // rich-text mappings:
        b: (chunks) => <b>{chunks}</b>,
        br: () => <br />,
        code: (chunks) => <code>{chunks}</code>,
        div: (chunks) => <div>{chunks}</div>,
        em: (chunks) => <em>{chunks}</em>,
        h3: (chunks) => <h3>{chunks}</h3>,
        i: (chunks) => <i>{chunks}</i>,
        li: (chunks) => <li>{chunks}</li>,
        ol: (chunks) => <ol>{chunks}</ol>,
        p: (chunks) => <p>{chunks}</p>,
        small: (chunks) => <small>{chunks}</small>,
        span: (chunks) => <span>{chunks}</span>,
        u: (chunks) => <u>{chunks}</u>,
        ul: (chunks) => <ul>{chunks}</ul>,
        strong: (chunks) => <strong>{chunks}</strong>
      }}
    />
  )
}